'use strict';

import {EvaluationBaseCtrl} from "../applications/evaluationbasectrl.js";
import {periodicReportChecklistModel} from "../../models/periodicreportchecklistmodel.js";

export class InvitationPeriodicReportChecklistCtrl extends EvaluationBaseCtrl {

    postConstruct(){
        const evaluation = this.jsDataService.get('evaluation', {});
        this.evaluation = new periodicReportChecklistModel(evaluation, this.$filter, this.jsDataService);

        this.changeUrl = this.jsDataService.get('changeUrl', '');
        this.cancelChangeUrl = this.jsDataService.get('cancelChangeUrl', '');
        this.pendingUrl = this.jsDataService.get('pendingUrl', '');
        this.confirmUrl = this.jsDataService.get('confirmUrl', '');
    }

    cancel = () => {
        const url = this.jsDataService.get('previewUrl');
        if(url){
            this.$scope.goUrl(url);
        }
    };

    save = () => {
        this.saveData();
    };

    saveData = () => {
        if(this.jsDataService.get('saveUrl')){
            this.$scope.basicHttpConfigProcess({
                url: this.jsDataService.get('saveUrl'),
                method: 'POST',
                data: {
                    questions: this.evaluation.form_data.getQuestionsData(),
                    fields: this.evaluation.form_data.getFieldsData(),
                    conclusion: this.evaluation.form_data.getConclusionData(),
                    version: this.evaluation.form_data.version,
                    additional_version: this.evaluation.form_data.additionalVersion,
                    periodic_report_version: this.evaluation.form_data.periodicReportVersion
                }
            }).then(() => {});
        }
        return null;
    };

    change = () => {
        if(this.changeUrl !== ''){
            this.$scope.basicHttpConfigProcess({
                url: this.changeUrl,
                method: 'GET'
            });
        }
    };

    pendingChange = (ev) => {
        if(this.pendingUrl !== ''){
            const confirmTexts = this.jsDataService.get('pendingConfirmTexts');
            const confirm = this.$mdDialog.confirm()
                .title(confirmTexts.title)
                .htmlContent(confirmTexts.content)
                .ariaLabel(confirmTexts.title)
                .targetEvent(ev)
                .ok(confirmTexts.ok)
                .cancel(confirmTexts.cancel);
            this.$mdDialog.show(confirm).then(() => {
                this.$scope.basicHttpConfigProcess({
                    url: this.pendingUrl,
                    method: 'GET',
                    responseType: 'json'
                }).then((results) => {
                    if(results.data.success){
                    }
                });
            }, () => {});
        }
    };

    confirm = (ev) => {
        if(typeof(this.removeUrl) !== 'undefined' && this.confirmUrl !== ''){
            const confirmTexts = this.jsDataService.get('confirmTexts');
            const confirm = this.$mdDialog.confirm()
                .title(confirmTexts.title)
                .htmlContent(confirmTexts.content)
                .ariaLabel(confirmTexts.title)
                .targetEvent(ev)
                .ok(confirmTexts.ok)
                .cancel(confirmTexts.cancel);
            this.$mdDialog.show(confirm).then(() => {
                this.$scope.basicHttpConfigProcess({
                    url: this.confirmUrl,
                    method: 'GET',
                    responseType: 'json'
                }).then((results) => {
                    if(results.data.success){
                    }
                });
            }, () => {});
        }
    };

    cancelChange = (ev) => {
        if(typeof(this.cancelChangeUrl) !== 'undefined' && this.cancelChangeUrl !== ''){
            const confirmTexts = this.jsDataService.get('removeConfirmTexts');
            const confirm = this.$mdDialog.confirm()
                .title(confirmTexts.title)
                .htmlContent(confirmTexts.content)
                .ariaLabel(confirmTexts.title)
                .targetEvent(ev)
                .ok(confirmTexts.ok)
                .cancel(confirmTexts.cancel);
            this.$mdDialog.show(confirm).then(() => {
                this.$scope.basicHttpConfigProcess({
                    url: this.cancelChangeUrl,
                    method: 'GET',
                    responseType: 'json'
                }).then((results) => {
                    if(results.data.success){
                    }
                });
            }, () => {});
        }
    };

    publishChange = (ev) => {
        this.$mdDialog.show({
            controller: ["$scope", "$mdDialog", "jsDataService", this.publishChangeDialogCtrl],
            templateUrl: 'invitations/publish_change.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:false,
            fullscreen: true,
            locals: {}
        }).then((results) => {
            if(typeof(this.item.status_url) !== 'undefined'){
                this.$scope.$root.basicHttpConfigProcess({
                    url: this.item.status_url,
                    method: 'POST',
                    responseType: 'json',
                    data: results
                });
            }
        }, () => {});
    };

    publishDialogCtrl($scope, $mdDialog, jsDataService){
        $scope.reject = function() {
            if(typeof(jsDataService.get('rejectUrl')) !== 'undefined' && jsDataService.get('rejectUrl') !== ''){
                $scope.$root.basicHttpConfigProcess({
                    url: jsDataService.get('rejectUrl'),
                    method: 'GET'
                }).then((response) => {
                    if(response.data.success){
                    }
                }, () => {});
            }
            $mdDialog.hide();
        };

        $scope.publish = function() {
            if(typeof(jsDataService.get('publishUrl')) !== 'undefined' && jsDataService.get('publishUrl') !== ''){
                $scope.$root.basicHttpConfigProcess({
                    url: jsDataService.get('publishUrl'),
                    method: 'GET'
                }).then((response) => {
                    if(response.data.success){
                    }
                }, () => {});
            }
            $mdDialog.hide();
        };

        $scope.close = function() {
            $mdDialog.cancel();
        };
    }

    publishChangeDialogCtrl($scope, $mdDialog, jsDataService){
        $scope.reject = function() {
            if(typeof(jsDataService.get('rejectChangeUrl')) !== 'undefined' && jsDataService.get('rejectChangeUrl') !== ''){
                $scope.$root.basicHttpConfigProcess({
                    url: jsDataService.get('rejectChangeUrl'),
                    method: 'GET'
                }).then((response) => {
                    if(response.data.success){
                    }
                }, () => {});
            }
            $mdDialog.hide();
        };

        $scope.publish = function() {
            if(typeof(jsDataService.get('publishChangeUrl')) !== 'undefined' && jsDataService.get('publishChangeUrl') !== ''){
                $scope.$root.basicHttpConfigProcess({
                    url: jsDataService.get('publishChangeUrl'),
                    method: 'GET'
                }).then((response) => {
                    if(response.data.success){
                    }
                }, () => {});
            }
            $mdDialog.hide();
        };

        $scope.close = function() {
            $mdDialog.cancel();
        };
    }

    renumberQuestions = () => {
        if (!this.evaluation || !this.evaluation.form_data || !this.evaluation.form_data.questions) {
            return;
        }

        const qKeys = Object.keys(this.evaluation.form_data.questions);
        qKeys.sort((a,b) => {
            const na = parseInt((a.match(/^prcq(\d+)$/) || [0,0])[1], 10);
            const nb = parseInt((b.match(/^prcq(\d+)$/) || [0,0])[1], 10);
            return na - nb;
        });

        let idx = 1;
        for (const key of qKeys) {
            const q = this.evaluation.form_data.questions[key];
            if (q && typeof q === 'object') {
                q.no = '' + idx;
            }
            idx++;
        }

        let baseNumber = qKeys.length + 1;
        if (this.evaluation.form_data.conclusion) {
            const cKeys = Object.keys(this.evaluation.form_data.conclusion);
            let cIdx = 1;
            for (const ck of cKeys) {
                const cItem = this.evaluation.form_data.conclusion[ck];
                if (cItem && typeof cItem === 'object') {
                    cItem.no = baseNumber + '.' + cIdx;
                }
                cIdx++;
            }
        }
    };

    addNewQuestion = () => {
        if (!this.evaluation || !this.evaluation.form_data) {
            return;
        }

        const keys = Object.keys(this.evaluation.form_data.questions || {});
        let lastIndex = keys.reduce((max, key) => {
            const m = key.match(/^prcq(\d+)$/);
            return m ? Math.max(max, parseInt(m[1], 10)) : max;
        }, 0);

        const newIndex = lastIndex + 1;
        const newKey = 'prcq' + newIndex;

        this.evaluation.form_data.questions[newKey] = {
            id: newKey,
            title: '',
            instruction: '',
            no: '' + newIndex,
            newQuestion: true
        };

        this.renumberQuestions();
    };

    removeNewQuestion = (ev, field) => {
        const confirmTexts = this.jsDataService.get('removeConfirmTexts');
        const confirm = this.$mdDialog.confirm()
            .title(confirmTexts.title)
            .htmlContent(confirmTexts.content)
            .ariaLabel(confirmTexts.title)
            .targetEvent(ev)
            .ok(confirmTexts.ok)
            .cancel(confirmTexts.cancel);

        this.$mdDialog.show(confirm).then(() => {
            if (field && field.id && this.evaluation.form_data.questions[field.id]) {
                delete this.evaluation.form_data.questions[field.id];
            }
            this.renumberQuestions();
        }, () => {});
    };

    getConclusionNumber = (conclusionItem, indexInRepeat) => {
        let questionCount = 0;
        if (this.evaluation && this.evaluation.form_data && this.evaluation.form_data.questions) {
            questionCount = Object.keys(this.evaluation.form_data.questions).length;
        }
        const baseNumber = questionCount + 1;
        return baseNumber + '.' + (indexInRepeat + 1);
    };
}
